import { render, staticRenderFns } from "./DepartmentSelector.vue?vue&type=template&id=3df6e350&scoped=true&"
import script from "./DepartmentSelector.vue?vue&type=script&lang=ts&"
export * from "./DepartmentSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentSelector.vue?vue&type=style&index=0&id=3df6e350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df6e350",
  null
  
)

export default component.exports